export const Vector = (props: { className?: string }) => {
    return (
        <div className={`Vector ${props.className}`}>
            <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.3834 11.6442C8.90935 11.6442 7.69169 10.3653 7.69169 8.81723C7.69169 7.26916 8.90935 5.99031 10.3834 5.99031C11.8574 5.99031 13.075 7.26916 13.075 8.81723C13.075 10.3653 11.8574 11.6442 10.3834 11.6442ZM10.3834 7.06723C9.42204 7.06723 8.653 7.87493 8.653 8.88454C8.653 9.89416 9.42204 10.7018 10.3834 10.7018C11.3447 10.7018 12.1137 9.89416 12.1137 8.88454C12.1137 7.87493 11.3447 7.06723 10.3834 7.06723Z"
                    fill="white"
                />
                <path
                    d="M10.3833 16.625C10.3192 16.625 10.2552 16.625 10.1911 16.5577C9.99881 16.4904 5 14.0673 5 9.15385C5 7.67308 5.57679 6.19231 6.60218 5.18269C7.56349 4.10577 8.97341 3.5 10.3833 3.5C11.7933 3.5 13.2032 4.10577 14.1645 5.18269C15.1899 6.25962 15.7667 7.67308 15.7667 9.15385C15.7667 14.2019 10.7679 16.4904 10.5756 16.5577C10.5115 16.625 10.4474 16.625 10.3833 16.625ZM10.3833 4.50962C9.22976 4.50962 8.07619 4.98077 7.24306 5.85577C6.40992 6.73077 5.96131 7.875 5.96131 9.15385C5.96131 12.9231 9.48611 15.0769 10.3833 15.5481C11.2806 15.0769 14.8054 12.9904 14.8054 9.15385C14.8054 7.94231 14.3567 6.73077 13.5236 5.85577C12.6905 4.98077 11.5369 4.50962 10.3833 4.50962Z"
                    fill="white"
                />
            </svg>
        </div>
    );
};
